export const getHeaders = (subKey: string = '', token: string = '', additionalHeaders?: { [key: string]: string }) => ({
    ...(subKey ? { 'Ocp-Apim-Subscription-Key': subKey } : {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    'Cache-Control': 'no-cache, no-store',
    'Pragma': 'no-cache',
    'Time-zone': Intl.DateTimeFormat().resolvedOptions().timeZone,
    ...additionalHeaders
});
